import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getToken } from './localStorage';

const ProtectedRoutes = (props: any) => {
  const { component: Component, ...rest } = props;
  return (
    <Route
      {...rest}
      render={(props) =>
        getToken() ? <Component {...props} /> : <Redirect to="login" />
      }
    />
  );
};

export default ProtectedRoutes;
